
import React from 'react'
import PersonalAccountLayout from 'layouts/PersonalAccountLayout';
import TrainingLists from 'components/User/Training/TrainingLists';

const TrainingCandidates = ({ match }) => {

    const { type } = match.params;
    return (
        <>
            <PersonalAccountLayout/>
            <TrainingLists type={type} />
        </>
    )
}

export default TrainingCandidates